import React, { FC } from 'react'
import { CURATOR } from 'lib/user/constants'
import Curator from '../../curatorProfile/layouts'
import Artist from './Artist'
import { getAccountType } from '../selectors'
import { useSelector } from 'react-redux'

const Component: FC = () => {
  const accountType = useSelector(getAccountType)
  return <>{accountType === CURATOR ? <Curator /> : <Artist />}</>
}

export default Component
